var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25.317,
    viewBox: "0 0 20 25.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30536",
    "data-name": "Group 30536",
    transform: "translate(-160.63 -451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30521",
    "data-name": "Group 30521",
    transform: "translate(141.13 456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30522",
    "data-name": "Group 30522",
    transform: "translate(20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30520",
    "data-name": "Group 30520",
    transform: "translate(0 1.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M19.646,22H10.371a.422.422,0,0,0,0,.838h9.275a.422.422,0,0,0,0-.838Z",
    transform: "translate(-7.725 -14.595)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M10.419,14.839H14.61a.419.419,0,1,0,0-.838H10.419a.419.419,0,1,0,0,.838Z",
    transform: "translate(-7.235 -8.989)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M20.017,30.42A.4.4,0,0,0,19.646,30H10.371a.422.422,0,0,0,0,.838h9.275A.4.4,0,0,0,20.017,30.42Z",
    transform: "translate(-7.725 -20.202)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M19.583,38.42a.468.468,0,0,0-.5-.419H10.5a.426.426,0,1,0,0,.838h8.574A.468.468,0,0,0,19.583,38.42Z",
    transform: "translate(-7.725 -25.809)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M10.383,46a.421.421,0,0,0,0,.838h5.363a.421.421,0,0,0,0-.838Z",
    transform: "translate(-7.151 -31.665)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M.6.607H9.319V4.852h4.209l.04,13.34h.6l-.04-13.769L9.744,0H0V18.192H14.088v-.606H.6Zm9.319.429L13.1,4.246H9.92Z",
    transform: "translate(0 -0.001)",
    fill: "#0074b0",
    stroke: "#0074b0",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17612",
    "data-name": "Path 17612",
    d: "M3696.312-2923.4h2.059v-17.984h-12.879v1.289",
    transform: "translate(-3681.886 2941.386)",
    fill: "none",
    stroke: "#0074b0",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlue);
export default __webpack_public_path__ + "static/media/copyIcon-blue.d6deb055e032625421af21d69432efb8.svg";
export { ForwardRef as ReactComponent };